import { FormikProps } from 'formik';
import { AddFromDatabaseFormValues } from './AddProductsFromDatabase';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import ProductsTable from 'src/app/pages/Products/ProductsTable';
import { Product, ProductWithVariants } from 'src/app/api/openapi';
import { useState } from 'react';
import { GridColDef } from '@mui/x-data-grid-premium';
import { RemoveCircle } from '@mui/icons-material';
import CustomDataGrid from 'src/app/components/CustomDataGrid';

const SelectProducts = ({
  values,
  setFieldValue,
}: FormikProps<AddFromDatabaseFormValues>) => {
  const toggleSelection = (row: ProductWithVariants) => {
    if (values.selectedProductIds[row.id]) {
      setFieldValue(
        'products',
        values.products.filter((product) => product.id !== row.id)
      );
      setFieldValue('selectedProductIds', {
        ...values.selectedProductIds,
        [row.id]: undefined,
      });
      return;
    }
    setFieldValue('products', [...values.products, row]);
    setFieldValue('selectedProductIds', {
      ...values.selectedProductIds,
      [row.id]: true,
    });
  };
  const [showSelectedProductModal, setShowSelectedProductModal] =
    useState(false);

  const handleNext = () => {
    setFieldValue('activeStep', 1);
  };

  const columns: GridColDef<ProductWithVariants>[] = [
    {
      headerName: '',
      field: 'remove',
      renderCell: ({ row }) => (
        <IconButton
          onClick={() => {
            setFieldValue(
              'products',
              values.products.filter((product) => product.id !== row.id)
            );
            setFieldValue('selectedProductIds', {
              ...values.selectedProductIds,
              [row.id]: undefined,
            });
          }}
        >
          <RemoveCircle color="error" />
        </IconButton>
      ),
      disableColumnMenu: true,
      sortable: false,
      width: 55,
    },
    {
      headerName: 'Name',
      field: 'title',
      renderCell: ({ row }) => <Box>{(row as Product).title || row.id}</Box>,
      width: 500,
    },
    {
      headerName: 'Price',
      field: 'suggested_prices',
      renderCell: ({ row }) => {
        const minPrice = row.variants.reduce(
          (min: number, variant: any) =>
            variant.suggested_prices &&
            variant.suggested_prices[0] &&
            variant.suggested_prices[0].amount < min
              ? variant.suggested_prices[0].amount
              : min,
          Infinity
        );
        return minPrice !== Infinity ? `Starting at $${minPrice}` : '';
      },
      width: 160,
    },
    {
      headerName: 'Categories',
      field: 'categories',
      renderCell: ({ row }) =>
        (row as ProductWithVariants).google_product_category?.name,
      width: 200,
    },
    {
      headerName: 'Number of Variants',
      field: 'variants',
      renderCell: ({ row }) => `${row.variants.length} Variants`,
      width: 200,
    },
  ];

  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        <Typography m={2} variant="h2">
          Add Products
        </Typography>
      </Stack>
      <ProductsTable
        toggleSelection={toggleSelection}
        selectedProductsIds={values.selectedProductIds}
      />
      <Box alignSelf="flex-end">
        <Button onClick={() => setShowSelectedProductModal(true)}>
          View {values.products.length} Selected Products
        </Button>
        <Button variant="flat" onClick={handleNext}>
          Next
        </Button>
      </Box>
      <Dialog open={showSelectedProductModal} fullScreen>
        <DialogContent>
          <CustomDataGrid rows={values.products} columns={columns} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowSelectedProductModal(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SelectProducts;
